import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import i18n from './services/i18n';
import './styles/main.scss';

// Axe has memory leak issues enable selectively
// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('@axe-core/react');
//   axe(React, ReactDOM, 2000);
// }

const AppWrapper = {
  run(config) {
    i18n.changeLanguage(config.languageCode);
    ReactDOM.render(
      <App config={config}/>,
      document.getElementById(config.mapId),
    );
  },
};

export default AppWrapper;
